// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2619) return "static/chunks/2619-4205dc2b3e4c0b82.js";
	if (chunkId === 5772) return "static/chunks/5772-ef4c513977b2b627.js";
	if (chunkId === 8680) return "static/chunks/8680-f18db6d427162653.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"7876":"e18b461d98467cfc","9576":"331a9c5b902a373e","9622":"c7e4ff55e7ce8821"}[chunkId] + ".js";
};